import * as api from "../api/userDetailAPI";
import * as types from "../constants/userDetailConstants";
import { transformUserProfileData } from "../../utils/skillDataTransformer";

export const getUserDetailAction = (userId) => async (dispatch) => {
  try {
    dispatch({
      type: types.GET_USER_DETAIL_LOADING,
    });

    const { error, data } = await api.getUserDetail(userId);

    if (error) {
      throw new Error(error);
    }

    // Check if access is denied
    if (data?.accessDenied) {
      dispatch({
        type: types.GET_USER_DETAIL_SUCCESS,
        payload: {
          rawData: data,
          transformedData: null,
          accessDenied: true,
          reason: data.reason,
          message: data.message
        },
      });
      return;
    }

    // Transform the API data for UI consumption
    const transformedData = transformUserProfileData(data);

    dispatch({
      type: types.GET_USER_DETAIL_SUCCESS,
      payload: {
        rawData: data,
        transformedData: transformedData
      },
    });
  } catch (error) {
    dispatch({
      type: types.GET_USER_DETAIL_FAIL,
      payload: error.message,
    });
  }
};

export const getUserDetailWithTokenAction = (userId, token) => async (dispatch) => {
  try {
    dispatch({
      type: types.GET_USER_DETAIL_LOADING,
    });

    const { error, data } = await api.getUserDetailWithToken(userId, token);

    if (error) {
      throw new Error(error);
    }

    // Transform the API data for UI consumption
    const transformedData = transformUserProfileData(data);

    dispatch({
      type: types.GET_USER_DETAIL_SUCCESS,
      payload: {
        rawData: data,
        transformedData: transformedData
      },
    });
  } catch (error) {
    dispatch({
      type: types.GET_USER_DETAIL_FAIL,
      payload: error.message,
    });
  }
};

export const clearUserDetailAction = () => (dispatch) => {
  dispatch({
    type: types.CLEAR_USER_DETAIL,
  });
};

